
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[slug]",
      function () {
        return require("private-next-pages/brands/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[slug]"])
      });
    }
  